import { render, staticRenderFns } from "./AddCompanyPage.vue?vue&type=template&id=95405d30&scoped=true&"
import script from "./AddCompanyPage.vue?vue&type=script&lang=js&"
export * from "./AddCompanyPage.vue?vue&type=script&lang=js&"
import style0 from "./AddCompanyPage.vue?vue&type=style&index=0&id=95405d30&scoped=true&lang=css&"
import style1 from "./AddCompanyPage.vue?vue&type=style&index=1&id=95405d30&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95405d30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95405d30')) {
      api.createRecord('95405d30', component.options)
    } else {
      api.reload('95405d30', component.options)
    }
    module.hot.accept("./AddCompanyPage.vue?vue&type=template&id=95405d30&scoped=true&", function () {
      api.rerender('95405d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/AddCompanyPage.vue"
export default component.exports